module.exports = __webpack_public_path__ + "img/request.31673a18.jpg";